// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * The following are shared across all platforms and apps
 */
* {
  font-size: 14px;
  color: var(--undp-jtf-btn-dark-color);
}

h6.text-muted {
  color: var(--undp-jtf-btn-dark-color);
  font-family: "OpenSans-Regular";
}
h6.text-muted span fa-icon {
  margin-right: 4px;
}
h6.text-muted span:nth-child(1n+2) {
  margin-left: 8px;
}

.form-control input[type=checkbox] {
  margin-top: 6px;
}

@media (max-width: 767px) {
  .btn-edit {
    font-size: 11px;
  }
}

.custom-select {
  position: absolute;
  width: 150px;
  top: 0;
  height: 2em;
  margin-top: 3px;
}

.post-title-link {
  font-size: 12px;
  cursor: pointer;
  text-decoration: none;
}

.post-selected-text {
  font-size: 12px;
  text-decoration: none;
  color: #007bff;
}

.custom-cross-icon {
  position: absolute;
  top: 0;
  right: 0;
}

.card-none {
  display: none;
}

.custom-column-wrapper {
  word-wrap: break-word;
}

.custom-add-card-body {
  padding: 0.3rem 0.8rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 10px;
}

.custom-add-card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: max-content;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
  overflow: auto;
  height: max-content;
}

.width50 {
  width: 50%;
}

.text-color {
  color: white;
}
.text-color fa-icon {
  color: white;
}`, "",{"version":3,"sources":["webpack://./libs/scss/_index.scss","webpack://./apps/hybrid-app/src/app/features/shared/post-viewers/post-comments/post-comment.component.scss","webpack://./apps/hybrid-app/src/scss/_variables.scss"],"names":[],"mappings":"AAAA;;EAAA;ACEA;EACE,eAAA;EACA,qCAAA;AAEF;;AACA;EACE,qCAAA;EACA,+BCJqB;ADMvB;AAAI;EACE,iBAAA;AAEN;AAAI;EACE,gBAAA;AAEN;;AAIE;EACE,eAAA;AADJ;;AAME;EADF;IAEI,eAAA;EAFF;AACF;;AAKA;EACE,kBAAA;EACA,YAAA;EACA,MAAA;EACA,WAAA;EACA,eAAA;AAFF;;AAKA;EACE,eAAA;EACA,eAAA;EACA,qBAAA;AAFF;;AAKA;EACE,eAAA;EACA,qBAAA;EACA,cAAA;AAFF;;AAKA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;AAFF;;AAKA;EACE,aAAA;AAFF;;AAKA;EACE,qBAAA;AAFF;;AAKA;EAEE,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AAHF;;AAMA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,qBAAA;EACA,sBAAA;EACA,2BAAA;EACA,sCAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;AAHF;;AAMA;EACE,UAAA;AAHF;;AAMA;EACE,YAAA;AAHF;AAIE;EACE,YAAA;AAFJ","sourcesContent":["/**\n * The following are shared across all platforms and apps\n */\n\n// shared variables\n@import 'variables';\n\n// create/import other scss files or define as needed...\n","@import '../../../../../../src/scss/variables';\n\n* {\n  font-size: 14px;\n  color: var(--undp-jtf-btn-dark-color);\n}\n\nh6.text-muted {\n  color: var(--undp-jtf-btn-dark-color);\n  font-family: $primary-font-regular;\n  span {\n    fa-icon {\n      margin-right: 4px;\n    }\n    &:nth-child(1n + 2) {\n      margin-left: 8px;\n    }\n  }\n}\n\n.form-control {\n  input[type='checkbox'] {\n    margin-top: 6px;\n  }\n}\n\n.btn-edit {\n  @media (max-width: 767px) {\n    font-size: 11px;\n  }\n}\n\n.custom-select {\n  position: absolute;\n  width: 150px;\n  top: 0;\n  height: 2em;\n  margin-top: 3px;\n}\n\n.post-title-link {\n  font-size: 12px;\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.post-selected-text {\n  font-size: 12px;\n  text-decoration: none;\n  color: #007bff;\n}\n\n.custom-cross-icon {\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n\n.card-none {\n  display: none;\n}\n\n.custom-column-wrapper {\n  word-wrap: break-word;\n}\n\n.custom-add-card-body {\n  // flex: 1 1 auto;\n  padding: 0.3rem 0.8rem;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  gap: 10px;\n}\n\n.custom-add-card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: max-content;\n  word-wrap: break-word;\n  background-color: #fff;\n  background-clip: border-box;\n  border: 1px solid rgba(0,0,0,.125);\n  border-radius: .25rem;\n  overflow: auto;\n  height: max-content;\n}\n\n.width50 {\n  width: 50%;\n}\n\n.text-color {\n  color: white;\n  fa-icon {\n    color: white;\n  }\n}","@import '@eview/scss/index';\n\n$primary-font: \"Montserrat\";\n$primary-font-bold: \"OpenSans-Bold\";\n$primary-font-medium: \"OpenSans-Light\";\n$primary-font-regular: \"OpenSans-Regular\";\n$primary-font-light: \"OpenSans-Light\";\n$primary-font-thin: \"OpenSans-Thin\";\n$secondary-font : \"Lato\";\n$secondary-font-bold: \"OpenSans-Bold\";\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
